import React from 'react'
import Select, { components } from 'react-select'
import styled, { useTheme } from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { getSelectTheme, getTheme } from 'Shared/theme'
import hexToRgba from 'hex-to-rgba'
import { Button } from 'react-bootstrap'

const SelectStyles = props => ({
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  singleValue: () => ({}),
  valueContainer: provided => ({
    ...provided,
    flexWrap: 'nowrap',
    paddingRight: '0px',
    paddingLeft: '0px'
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '14.5px',
    backgroundColor: state.isSelected
      ? `${props.themeColor} !important`
      : state.isFocused || state.isActive
        ? hexToRgba(props.themeColor, 0.15)
        : 'inherit',
    color: state.isSelected ? `${getTheme(props.theme.id).white} !important` : 'inherit',
    ':active': {
      backgroundColor: hexToRgba(props.themeColor, 0.15)
    }
  }),
  control: () => ({
    border: 'none'
  }),
  menu: (provided, state) => ({
    ...provided,
    boxShadow: getSelectTheme(props.theme.id).boxShadow,
    border: `1px solid ${getSelectTheme(props.theme.id).borderColor}`,
    zIndex: 101,
    minWidth: 120,
    left: 0
  })
})

const Versions = ({ versionOptions, versions, version, themeColor, namespace, workspace, slug }) => {
  const selectedVersion = versions[version.toString()]
  const navigate = useNavigate()
  const theme = useTheme()

  const onChange = value => {
    navigate(`/${value.relative_path}`)
  }

  return (
    <>
      {selectedVersion && versionOptions && versionOptions.length > 0 && (
        <Wrapper className="me-1">
          <SelectWrapper $themeColor={themeColor}>
            <Select
              styles={SelectStyles({ readOnly: true, themeColor, theme })}
              menuPlacement="auto"
              components={{ SingleValue, DropdownIndicator: false, IndicatorSeparator: null }}
              theme={props => ({
                colors: {
                  ...props.colors,
                  ...getSelectTheme(theme.id)
                },
                borderRadius: 3,
                spacing: {
                  controlHeight: 34,
                  baseUnit: 3,
                  menuGutter: 6
                }
              })}
              versionOptions
              getOptionLabel={option => option.title}
              getOptionValue={option => option.id}
              value={selectedVersion}
              options={versionOptions}
              onChange={onChange}
              isSearchable={false}
            />
          </SelectWrapper>
        </Wrapper>
      )}
    </>
  )
}

const SingleValue = ({ ...props }) => {
  const { data } = props
  const { title } = data

  return (
    <components.SingleValue {...props}>
      <SelectButton variant="tertiary" size="xs" className="d-flex align-items-center">
        <SelectTitle>{title}</SelectTitle>
        <svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation" style={{ marginRight: -6 }}>
          <path
            d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </svg>
      </SelectButton>
    </components.SingleValue>
  )
}

const Wrapper = styled.div`
  display: flex;
  padding: 0 8px;
`

const SelectWrapper = styled.div`
  flex-direction: row;
  width: 100%;
  align-items: center;
  display: flex;
`

const SelectButton = styled(Button)`
  border-radius: 0.225rem;
  font-size: 0.925rem;
  height: 28px;
`

const SelectTitle = styled.div`
  overflow: hidden;
  max-width: 150px;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 25px;
`

export default Versions
